import { render, staticRenderFns } from "./PostsPreviewCouponCode.vue?vue&type=template&id=27694796&scoped=true&"
import script from "./PostsPreviewCouponCode.vue?vue&type=script&lang=js&"
export * from "./PostsPreviewCouponCode.vue?vue&type=script&lang=js&"
import style0 from "./PostsPreviewCouponCode.vue?vue&type=style&index=0&id=27694796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27694796",
  null
  
)

export default component.exports